export const packagesResultRootRoute = 'packages-result';
export const packagesResultCalendarRoute = 'calendar';
export const packagesResulDetailRoute = 'route-detail';
export const packagesHotelResulFiltersRoute = 'hotel-filters';
export const packagesFlightResulFiltersRoute = 'flight-filters';
export const packagesResulUpsellRoute = 'upsell';
export const singleHotelFilterRoute = 'hotel-single-filter';
export const singleAirFilterRoute = 'air-single-filter';

export const detailPackageOulet = 'detail';

export const STEP_SECTION = 'STEP_SECTION';
